export default __webpack_public_path__ + "img/dxcRndgy.f8c5f78e.svg";